import { ROLES } from '@/shared/constants/roles';
import { AI_PACKAGE_FEATURE_KEYS, AI_PACKAGE_FLAGS } from '@/shared/constants/packageFeatures';

export const kcRoutes = [
  {
    path: 'courses',
    name: 'courses',
    component: () => import('./views/CoursesView.vue'),
    meta: { requiredRole: ROLES.INSTRUCTOR },
  },
  {
    path: 'courses/manage',
    name: 'manage-mcs',
    component: () => import('./views/ManageMCsView.vue'),
    meta: { requiredRole: ROLES.INSTRUCTOR },
  },
  {
    path: 'courses/content-customization',
    name: 'content-customization',
    component: () => import('./views/ContentCustomizationView.vue'),
    meta: {
      requiredRole: ROLES.INSTRUCTOR,
      requiredFeature: AI_PACKAGE_FEATURE_KEYS.CONTENT_TOOLS,
      requiredFeatureFlag: AI_PACKAGE_FLAGS.customizeExistingContentForCareer,
    },
  },
  {
    path: 'courses/kc-customization',
    name: 'kc-customization',
    component: () => import('./views/KCCustomizationView.vue'),
    meta: { requiredRole: ROLES.INSTRUCTOR },
  },
  {
    path: 'knowledge-checks',
    name: 'knowledge-checks',
    component: () => import('./views/KCListView.vue'),
    meta: { requiredRole: ROLES.INSTRUCTOR },
  },
  {
    path: 'knowledge-checks/content-customization',
    name: 'knowledge-checks-content-customization',
    component: () => import('./views/KCListView.vue'),
    meta: {
      requiredRole: ROLES.INSTRUCTOR,
      requiredFeature: AI_PACKAGE_FEATURE_KEYS.CONTENT_TOOLS,
      requiredFeatureFlag: AI_PACKAGE_FLAGS.customizeExistingContentForCareer,
    },
  },
  {
    path: 'knowledge-checks/kc-customization',
    name: 'knowledge-checks-kc-customization',
    component: () => import('./views/KCListView.vue'),
    meta: { requiredRole: ROLES.INSTRUCTOR },
  },
  {
    path: 'knowledge-checks/manage',
    name: 'manage-kcs',
    component: () => import('./views/ManageKCsView.vue'),
    meta: { requiredRole: ROLES.INSTRUCTOR },
  },
  {
    path: 'knowledge-checks/assessment',
    name: 'assessment-list',
    component: () => import('./views/AssessmentListView.vue'),
    meta: { requiredRole: ROLES.INSTRUCTOR },
  },
  {
    path: 'editor/:contentId',
    name: 'editor',
    component: () => import('./views/EditorView.vue'),
    meta: { requiredRole: ROLES.INSTRUCTOR },
  },
  {
    path: 'archived-content/:courseId/:entityId',
    name: 'archived-content',
    component: () => import('./views/ArchivedContentView.vue'),
    meta: { requiredRole: ROLES.INSTRUCTOR },
  },
];